// Single place browser-facing S3 asset URLs are built from a bucket + object key
// (DEV-12183). Mirrors bronco's integration/aws PublicURL:
//   S3_PUBLIC_URL unset  -> https://<bucket>.s3.amazonaws.com/<key>   (real AWS, as before)
//   S3_PUBLIC_URL set    -> <base>/<bucket>/<key>                     (LocalStack, path-style)
// key is emitted as-is — callers that percent-encode keep doing it. Set the base in
// docker/.env (S3_PUBLIC_URL, e.g. http://localhost:4566); rooster.sh passes it through
// as the canonical `<EXEC>_<ENV>_S3_PUBLIC_URL` key in window._env_. Read that key
// directly, NOT via window._getEnv: its URL-search-param override (?s3_public_url=…)
// would let a crafted link point every asset URL at another origin.
export const s3PublicBase = () => {
	try {
		const env = window._env_ || {};
		const base = env[`${String(env.EXEC).toUpperCase()}_${String(env.ENV).toUpperCase()}_S3_PUBLIC_URL`];
		return typeof base === 'string' ? base.replace(/\/+$/, '') : '';
	} catch (e) {
		return '';
	}
};

// Buckets the local store actually holds. account_port --media / docker/localstack/seed_stock.sh
// copy only ts-condor-assets (library, thumbnails, layout-group assets, custom css), and the
// Vulture uploaders for every other bucket still write to real AWS through ui/app/src/S3.js.
// Rewriting those buckets' display URLs to LocalStack would 404 every Pelican thumbnail,
// screenshot and theme-editor photo in local mode; they stay on the AWS host until their
// upload path and a seed flow are endpoint-aware too.
export const LOCAL_STORE_BUCKETS = ['ts-condor-assets'];

export const s3PublicURL = (bucket, key = '') => {
	const cleanKey = String(key).replace(/^\/+/, '');
	const base = s3PublicBase();
	if (base && LOCAL_STORE_BUCKETS.includes(bucket)) {
		return `${base}/${bucket}/${cleanKey}`;
	}
	return `https://${bucket}.s3.amazonaws.com/${cleanKey}`;
};
